export default [
  {
    key: 'id',
    type: 'id',
  },
  {
    key: 'name',
    label: 'Nama Layanan',
    sortable: true,
  },
  {
    key: 'courier_name',
    label: 'Kurir',
    sortable: true,
  },
  {
    key: 'code',
    label: 'Kode',
    sortable: true,
  },
  {
    key: 'category',
    label: 'Kategori',
    type: 'badge',
    translationPrefix: 'courier_service.',
    map: {
      economy: 'secondary',
      regular: 'primary',
      nextday: 'info',
      sameday: 'success',
      cargo: 'warning',
      document: 'dark',
    },
    filter: {
      key: 'category',
      type: 'select',
      label: 'Kategori',
      options: [
        { value: 'economy', text: 'Economy' },
        { value: 'regular', text: 'Regular' },
        { value: 'nextday', text: 'Nextday' },
        { value: 'sameday', text: 'Sameday' },
        { value: 'cargo', text: 'Cargo' },
        { value: 'document', text: 'Document' },
      ],
    },
  },
  {
    key: 'enabled',
    label: 'Aktif',
    type: 'boolean',
  },
]
